// 语言
export const LOCAL_ENUM = {
  ZH_CN: "zh-CN",
  EN_US: "en-US",
}
